import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'strReplace',
    standalone: false
})
export class StrReplacePipe implements PipeTransform {
    transform(value: any, search: string, replace: string): string {
        if (!value || !search ) {
            return value;
        }
        return value.toString().split(search).join(replace);
    }
}
@NgModule({
    declarations: [StrReplacePipe],
    exports: [StrReplacePipe],
})
export class StrReplacePipeModule {}